// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"7b624809","784":"4a2f8210"}[chunkId] + ".chunk.js";
};